import { getAreaUser } from 'pages/common/helpers/get-area-user.helper';
import { ANY_ROOM_TYPE } from 'pages/common/const';
import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';
import { LaminateInputs } from '../../../types';

const formatValue = (value: string | null): number | null => {
  if (!value) {
    return null;
  }
  return Number(value.replace(/,/g, '.'));
};

export const getProjectConfigurationParameters = (
  inputsData: LaminateInputs
): Array<TProjectConfigurationParameter> => {
  let projectConfigurationParameters = [];
  const formattedData = { ...inputsData };
  formattedData.area = getAreaUser({
    ...(inputsData.width ? { width: formatValue(inputsData.width) } : {}),
    ...(inputsData.length ? { length: formatValue(inputsData.length) } : {}),
    ...(inputsData.area ? { areaUser: formatValue(inputsData.area) } : {}),
  }).toString();

  if (formattedData.roomType && formattedData.roomType !== ANY_ROOM_TYPE) {
    projectConfigurationParameters.push({
      key: 'roomType',
      value: inputsData.roomType,
    });
  }

  if (Boolean(formattedData.width) && Boolean(formattedData.length)) {
    projectConfigurationParameters.push({
      key: 'width',
      value: formattedData.width!,
    });
    projectConfigurationParameters.push({
      key: 'length',
      value: formattedData.length!,
    });
  }

  if (Boolean(formattedData.area)) {
    projectConfigurationParameters.push({
      key: 'area',
      value: formattedData.area,
    });
  }

  if (Boolean(formattedData.layingType)) {
    projectConfigurationParameters.push({
      key: 'layingType',
      value: formattedData.layingType!,
    });
  }

  return projectConfigurationParameters;
};
